import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import * as types from "./types";

export interface AuthState {
  user?: types.LoginResponseDto;
}
const initialState: AuthState = {
  user: undefined,
};
const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    setUser: (
      state,
      action: PayloadAction<types.LoginResponseDto | undefined>
    ) => {
      state.user = action.payload;
    },
    logout: (state) => {
      state.user = undefined;
    },
  },
});

export default authSlice.reducer;
export const { setUser, logout } = authSlice.actions;
